// Components==============
import { faEye } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/UI/Avatar/Avatar';
import Tooltip from 'components/UI/Tooltip/Tooltip';
import { useRedux } from 'hooks/useRedux';
import { ReflectContext } from 'pages/Growth/Reflect/Reflect';
import React, { useContext } from 'react';
import { sortMembers } from 'utilities/sortMembers';
import './MemberBar.module.scss';
// =========================

export default function MemberBar() {
  const { project } = useContext(ReflectContext);

  const members = sortMembers(project)?.map((m) => m.member);
  return (
    <div styleName="scroll-wrapper">
      <div styleName="wrapper">
        {members?.map((m) => (
          <Tooltip
            position="top"
            content={
              <p>
                {m.user?.first_name} {m.user?.last_name}
              </p>
            }
            key={m.id}
          >
            <Avatar user={m.user} />
            {!!(m?.membership === 'teacher' || m?.membership === 'extern') && (
              <div styleName="invited">
                <FontAwesomeIcon icon={faEye} />
              </div>
            )}
          </Tooltip>
        ))}
      </div>
    </div>
  );
}
